/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


import intersect from '@alpinejs/intersect'
Alpine.plugin(intersect)

require("owl.carousel/dist/owl.carousel.min.js");

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()
//  window.$ = window.jQuery = require('jquery');
//  window.Swal = require('sweetalert2');
 import bootstrap from 'bootstrap'
//  import 'livewire-sortable'
require('../bootstrap');
require('../plugins');

import('preline');

window.Swal = require('sweetalert2');
window.select2 = require('select2');

import './main.js';
// $(function(){
//     let snapMixin = Swal.mixin({
//         toast: true,
//         icon: 'success',
//         // title: 'Welcome to Snap Club',
//         // animation: true,
//         position: 'bottom-right',
//         showConfirmButton: false,
//         confirmButtonColor: '#3085d6',
//         cancelButtonColor: '#d33',
//         customClass: {
//             confirmButton: 'btn-fill',
//             cancelButton: 'btn-fill'
//         },
//         buttonsStyling: false,
//         timer: 5000,
//         timerProgressBar: true,
//         didOpen: (toast) => {
//             toast.addEventListener('mouseenter', Swal.stopTimer)
//             // toast.addEventListener('mouseover', Swal.increaseTimer(3000-Swal.getTimerLeft()))
//             toast.addEventListener('mouseleave', Swal.resumeTimer)
//         }
//     });
// });

// import Masonry from 'masonry-layout';

// import Vue from 'vue';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });
